/**
 * Merged business_*_data — serialisierte RMW (Phase 3).
 */

import { queueBusinessPayloadWrite, queueBusinessPayloadFieldWrite } from '../storage/businessPayloadWrite';
import {
  readBestBusinessMergedPayload,
  consolidateBusinessMergedPayloadToCanonical
} from '../../utils/sharedCore';

export class KvBusinessPayloadRepository {
  /**
   * @param {string} businessId
   * @param {(parsed: object) => object|Promise<object>} mutator
   * @param {{ authoritativeFields?: string[], allowInSafeMode?: boolean }} [options]
   */
  mutatePayload(businessId, mutator, options = {}) {
    return queueBusinessPayloadWrite(businessId, mutator, options);
  }

  readBest(businessId) {
    return readBestBusinessMergedPayload(businessId);
  }

  consolidateToCanonical(businessId) {
    return consolidateBusinessMergedPayloadToCanonical(businessId);
  }

  /**
   * Ein Feld im merged Blob (serialisiert, merge-sicher).
   */
  setField(businessId, field, value) {
    return queueBusinessPayloadFieldWrite(businessId, field, value);
  }

  /**
   * Mehrere Felder atomar (serialisiert).
   */
  setFields(businessId, updates) {
    const fields = Object.keys(updates || {});
    return queueBusinessPayloadWrite(
      businessId,
      (parsed) => {
        Object.entries(updates).forEach(([field, value]) => {
          parsed[field] = value;
        });
        return parsed;
      },
      { authoritativeFields: fields }
    );
  }
}
